import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import FormCheckbox from "@mui/joy/Checkbox";
import { Controller } from "react-hook-form";
import Typography from "@mui/joy/Typography";
import FormLabel from "@mui/joy/FormLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/joy/Tooltip";
import Stack from "@mui/joy/Stack";
import { SxProps } from "@mui/system";

interface Props {
  name: string;
  label?: string | JSX.Element;
  control: any;
  infoText?: string;
  helperText?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  labelSx?: SxProps;
  onValueChange?: (checked: boolean) => void;
}

const Checkbox = ({
  name,
  label,
  helperText,
  required,
  infoText,
  control,
  error,
  disabled,
  labelSx,
  onValueChange,
}: Props) => {
  return (
    <FormControl
      key={name}
      sx={{
        width: "100%",
      }}
      size="md"
      error={!!error}
    >
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Stack direction={"row"} gap={1.5} alignItems={"flex-start"}>
            <FormCheckbox
              {...field}
              size="md"
              disabled={disabled}
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
                onValueChange && onValueChange(e.target.checked);
              }}
              sx={{
                borderColor: error ? "success.500" : "",
                "& :disabled": {
                  cursor: "not-allowed !important",
                },
              }}
            />
            {label && (
              <FormLabel
                sx={[
                  {
                    fontWeight: "lg",
                    mb: 0,
                  },
                  ...(Array.isArray(labelSx) ? labelSx : [labelSx]),
                ]}
                required={required}
              >
                {infoText && (
                  <Tooltip
                    title={infoText}
                    sx={{
                      maxWidth: "250px",
                    }}
                    arrow
                    placement="right"
                  >
                    <InfoOutlinedIcon
                      sx={{
                        fontSize: 15,
                        mr: 0.5,
                      }}
                    />
                  </Tooltip>
                )}
                {label}
              </FormLabel>
            )}
            {!label && infoText && (
              <Tooltip
                title={infoText}
                sx={{
                  maxWidth: "250px",
                }}
                arrow
                placement="right"
              >
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 15,
                  }}
                />
              </Tooltip>
            )}
          </Stack>
        )}
      />

      {helperText && <Typography sx={{ mt: 0.6, fontSize: "xs", color: "neutral.700" }}>{helperText}</Typography>}

      {error && (
        <FormHelperText
          sx={{
            fontSize: "xs",
          }}
        >
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default Checkbox;
